module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stf-select-option",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.selectValue,
      "keydown": _vm.keyDown
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9f77d7a"}!./src/components/stf-select/stf-select-option.html
// module id = 107
// module chunks = 1